module.exports = __webpack_public_path__ + "static/img/vote-02.3dae2bd.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/vote/vote-02.png
// module id = Icl/
// module chunks = 1